import { AxiosError } from "axios";

export const notification = {
  success(message: string = "Успешно") {
    const event = new CustomEvent("notification.success", {
      bubbles: true,
      detail: message,
    });
    document.dispatchEvent(event);
  },
};

export const getError = (error: AxiosError) => {
  let message =
    "Возникла внутренняя ошибка сервера. Повторите запрос позднее, если проблема сохранится — свяжитесь с администратором";

  if (error.status === 500) {
    return message;
  }

  message =
    (error?.response?.data as any)?.error ||
    (error?.response?.data as any)?.message ||
    message;

  return message;
};
